import React, {Component} from "react";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from '@material-ui/core/Button';
import Back from '@material-ui/icons/ArrowBack';
import OptionsPicker from './OptionsPicker';
import ShowReports from './ShowReports';

const styles = ({
  container: {
    display: "flex",
    flexWrap: "wrap",
    margin: "0px 20px 20px 20px"
  },
  leftIcon: {
    marginRight: 1,
  },
  header: {
    marginBottom: "15px"
  }
})

class Report extends Component{
  constructor(props){
    super(props);
    this.state = {
      coinsForEachServerPerMinute: [],
      is_plugin: null
    };

    this.child = {};
  }

  onUsageGetSuccess = response => {
    if(!response.error){     
      const { data, summaryReports, coinsForEachServerPerMinute, balance, briefReports, cores} = response;
      let reports = [];
      let usersData = null;
      if(summaryReports !== undefined){
        reports = summaryReports;
        usersData = data;
      }else{
        reports = data;
      }     
      this.setState({
        reports,
        coinsForEachServerPerMinute,
        briefReports,
        cores,
        allUsersData: usersData,
        userBalance: balance 
      })
    }else{
      this.setState({ reports: [] });
    }
  }

  onUsageGetError = () => {
    this.setState({ reports: [], allUsersData: null });
  }

  render(){  
    const { classes, isSuperuser, backToMainPage } = this.props; 
    const { reports, allUsersData, coinsForEachServerPerMinute, userBalance, briefReports, cores } = this.state;
    return (
      <Grid className={classes.container}>
        <Grid item xs={12} className={classes.header}>
          <Button color="primary" className={classes.button} onClick={backToMainPage}>
            <Back className={classes.leftIcon}/>
            Back
          </Button>
        </Grid>
        <Grid item xs={3}>
          <OptionsPicker isSuperuser={isSuperuser}
                         is_plugin={this.state.is_plugin}
                         onUsageGetSuccess={this.onUsageGetSuccess} 
                         onUsageGetError={this.onUsageGetError}
                         onRef={ref => (this.child = ref)}  />
        </Grid>
        {
          reports && 
          <Grid item xs={9}>
            <ShowReports isSuperuser={isSuperuser} 
                        reports={reports}
                        usersData={allUsersData}
                        coinsForEachServerPerMinute={coinsForEachServerPerMinute} 
                        getUserReport={this.child.getUserReport}
                        userBalance={userBalance}
                        briefReports={briefReports}
                        coreNames={cores}
                        is_plugin={this.state.is_plugin}
                        usageChange={(mode)=>{this.setState({is_plugin:mode})}}
                      />
        </Grid>
        }
      </Grid>
    );
  }
}

export default withStyles(styles)(Report);
